/**
 * "A count may just have moved" — STORY-171 (SU-D16).
 *
 * Announced by the calls that move stock (completing a visit, correcting a
 * count, opening a unit) and heard by the low-stock popup, which then asks the
 * server at once. That is what makes the popup immediate for the person whose
 * action made an item low, without every caller knowing a popup exists.
 */
export const STOCK_MOVED = "dentacore:stock-moved";

export function announceStockMoved(): void {
  window.dispatchEvent(new Event(STOCK_MOVED));
}
